
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';

import NavbarBreadcrumbs from '../components/NavbarBreadcrumbs';
import ColorModeIconDropdown from '../theme/ColorModeIconDropdown';
import OptionsMenu from '../components/OptionsMenu';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';

export default function Header() {
    const location = useLocation();
    const { _getUser } = useAuth();
    const [user, setUser] = useState(_getUser() || null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    // Check if token is in URL and fetch user data if needed
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tokenFromUrl = urlParams.get('token');
        
        const fetchUserFromToken = async () => {
            if (tokenFromUrl) {
                try {
                    // Fetch user data using the token from URL
                    const response = await api.get('user/me');
                    const userData = response.data.data;
                    // Store in component state only (not localStorage to avoid affecting super admin tab)
                    setUser(userData);
                } catch (error) {
                    console.error('Failed to fetch user from token:', error);
                    // Fallback to localStorage user if fetch fails
                    const storedUser = _getUser();
                    if (storedUser) {
                        setUser(storedUser);
                    }
                }
            } else {
                // Use user from localStorage if no token in URL
                const storedUser = _getUser();
                if (storedUser) {
                    setUser(storedUser);
                }
            }
        };

        fetchUserFromToken();
    }, [location.search, _getUser]);

    const userName = user?.name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'User';

    const handleAvatarClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <Stack
            direction="row"
            sx={{
                display: { xs: 'none', md: 'flex' },
                width: '100%',
                alignItems: { xs: 'flex-start', md: 'center' },
                justifyContent: 'space-between',
                maxWidth: { sm: '100%', md: '1700px' },
                pt: 1.5,
            }}
            spacing={2}
        >
            <NavbarBreadcrumbs />
            <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
                <ColorModeIconDropdown />
                {user && (
                    <>
                        <Avatar
                            sizes="small"
                            alt={userName}
                            src="/static/images/avatar/7.jpg"
                            sx={{ 
                                width: 36, 
                                height: 36,
                                cursor: 'pointer',
                                '&:hover': {
                                    opacity: 0.8
                                }
                            }}
                            onClick={handleAvatarClick}
                        />
                        <OptionsMenu 
                            user={user} 
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                        />
                    </>
                )}
            </Stack>
        </Stack>
    );
}
